<template>
  <div class="t-datepicker-wrapper" :class="{ error: error }">
    <div
      class="t-datepicker row6"
      :class="{ open: dataPickerVisible, error: error }"
      v-click-outside="closeBlock"
      @click="onclick"
    >
      <div class="t-datepicker__placeholder" @click="setDataPickerVisible">
        <span v-if="!value" class="t-datepicker__placeholder-text grey"
          >Дата</span
        >
        <span v-if="value" class="t-datepicker__placeholder-text">{{
          value
        }}</span>
      </div>

      <div class="t-datepicker__select-date-wrapper">
        <span class="t-datepicker__arrow" @click="prevMonth">
          <svg viewBox="0 0 13 8" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.646446 4.35355C0.451184 4.15829 0.451184 3.84171 0.646446 3.64645L3.82843 0.464467C4.02369 0.269205 4.34027 0.269205 4.53553 0.464467C4.7308 0.659729 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM13 4.5L1 4.5L1 3.5L13 3.5L13 4.5Z"
            />
          </svg>
        </span>
        <span class="t-datepicker__select-date"
          >{{ months[month] }}, {{ year }}</span
        >
        <span class="t-datepicker__arrow" @click="nextMonth">
          <svg viewBox="0 0 13 8" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.3536 4.35355C12.5488 4.15829 12.5488 3.84171 12.3536 3.64645L9.17157 0.464467C8.97631 0.269205 8.65973 0.269205 8.46447 0.464467C8.2692 0.659729 8.2692 0.976311 8.46447 1.17157L11.2929 4L8.46447 6.82843C8.2692 7.02369 8.2692 7.34027 8.46447 7.53553C8.65973 7.7308 8.97631 7.7308 9.17157 7.53553L12.3536 4.35355ZM-4.37114e-08 4.5L12 4.5L12 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
            />
          </svg>
        </span>
      </div>
      <div class="t-datepicker__week-day">
        <span v-for="(item, index) in weekdays" :key="index">{{ item }}</span>
      </div>
      <div class="t-datepicker__number-day">
        <span
          v-for="(item, index) in days"
          :key="month + year + item + index + Date.now()"
          :class="{
            on: item && checkActiveDelivery(item),
            off: item && !checkActiveDelivery(item),
          }"
          @click="() => checkActiveDelivery(item) && setSelectDate(item)"
          >{{ item }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      dataPickerVisible: false,
      weekdays: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
      value: null,
      date: null,
      day: null,
      month: null,
      year: null,
      currentDays: null,
      selectDate: {
        day: null,
        month: null,
        year: null,
      },
      months: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ],
    };
  },
  props: ['error'],
  computed: {
    days: function() {
      let dayIndex = 1;

      let maxBlocks = 42;

      return new Array(maxBlocks).fill('').map((item, index) => {
        const day = new Date(this.year, this.month, dayIndex).getDate();

        if (new Date(this.year, this.month, 1).getDay()) {
          if (
            index + 1 >= new Date(this.year, this.month, 1).getDay() &&
            dayIndex <= this.currentDays
          ) {
            dayIndex++;

            return new Date(this.year, this.month, day).getDate();
          } else return '';
        } else {
          if (!new Date(this.year, this.month, 1).getDay() && index < 6) {
            return '';
          }

          if (dayIndex <= this.currentDays) {
            dayIndex++;
            return day;
          }

          return '';
        }
      });
    },
  },
  watch: {
    value() {
      this.$emit('change', this.value);
    },
  },
  methods: {
    setDataPickerVisible: function() {
      this.dataPickerVisible = !this.dataPickerVisible;
    },
    closeBlock: function() {
      this.dataPickerVisible = false;
    },
    init: function() {
      this.date = new Date();
      this.day = this.date.getDate();
      this.month = this.date.getMonth();
      this.year = this.date.getFullYear();
      this.currentDays = this.getDaysInMonth(this.month + 1, this.year);
    },
    getDaysInMonth: function(month, year) {
      return new Date(year, month, 0).getDate();
    },
    nextMonth: function() {
      this.month++;
      if (this.month > 11) {
        this.month = 0;
        this.year++;
      }
      this.currentDays = this.getDaysInMonth(this.month + 1, this.year);
    },
    prevMonth: function() {
      this.month--;
      if (this.month < 0) {
        this.month = 11;
        this.year--;
      }
      this.currentDays = this.getDaysInMonth(this.month + 1, this.year);
    },
    prevYear: function() {
      this.year--;
    },
    nextYear: function() {
      let nowYear = new Date();
      if (this.year < nowYear.getFullYear()) {
        this.year++;
      }
    },
    setSelectDate: function(day) {
      if (day) {
        this.selectDate = {
          day,
          month: this.month,
          year: this.year,
        };
        this.value = `${this.formatDate(
          this.selectDate.day
        )} / ${this.formatDate(this.selectDate.month + 1)} / ${
          this.selectDate.year
        }`;
        this.dataPickerVisible = false;
      }
    },
    formatDate: function(value) {
      if (value > 0 && value < 10) {
        return '0' + value;
      }
      return value;
    },
    checkActiveDelivery: function(value) {
      if (
        new Date(this.year, this.month, value).getDay() !== 0 &&
        Date.now() < new Date(this.year, this.month, value).getTime()
      ) {
        if (
          new Date().getHours() >= 18 &&
          Math.abs(
            new Date(this.year, this.month, value).getTime() -
              new Date(Date.now()).getTime()
          ) < 86400001
        ) {
          return false;
        } else return true;
      } else return false;
    },
    onclick: function() {
      this.$emit('onclick', this.value);
    },
  },
  created() {
    this.init();
  },
  mounted() {
    console.log('errror', this.error);
  },
};
</script>

<style lang="sass" scoped>
.t-datepicker
  width: 260px
  height: 48px
  padding: 0 24px
  border: 1px solid #A0AFC5
  border-radius: 50px
  overflow: hidden
  transition: height .2s, border-radius .2s .1s
  &-wrapper
    &.error
      position: relative
      &:after
        content: 'Выберите время'
        position: absolute
        bottom: -13px
        left: 24px
        color: #F24949
        font-size: 10px
        line-height: 1
  &.error
    border: 1px solid #F24949
  &.open
    background-color: #FFFFFF
    box-shadow: 0px 3px 8px rgba(172, 185, 204, 0.3)
    border-radius: 24px
    transition: height .2s, border-radius 0s 0s
    .t-datepicker__placeholder
      opacity: .5
    &.row4
      height: 250px
    &.row5
      height: 270px
    &.row6
      height: 300px

  &__placeholder
    position: relative
    cursor: pointer
    &-text
      font-size: 16px
      line-height: 46px
      color: #000000
      &.grey
        opacity: 0.5
      &:after
        content: ''
        position: absolute
        width: 18px
        height: 18px
        top: 50%
        right: 0
        transform: translateY(-50%)
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEoSURBVHgBtZPRTcNADIb/M7cH7QZ9RxVZoWIAkhGYgLABTJAyQOkKQQXxCBskc6DGhx1iGsKpSG36PeQs578/PvsC9FiuX6vHp7dr/EOxeklV28+5YrXJ24j80oGrwHwn6RoIk5gJeV/xdjt1RLcBn1OwTzXvNdE6Er8HRq3CwI28pCRmJB/6ALkHCWvZPrH9tBPgPoCzwGEmtlGTjhnh7Dw0zY0DFT9Hk7MGjABhJLw+tMHZ1TzHAeiwtE9+mLRYjYv1JgEjaROEMlvMy6HmV0WGTaAjVxPLSdW6lH80HeP2yPi+jD3kOF0lbRzVxIyGDdeeyFLu00SN+ncqXVw4m4hVoiZDza74kThNs/ulKl0/8n0aw/41nc4zDkB6eClLYhXpxUtwBF/caoekkE8OkwAAAABJRU5ErkJggg==)
        background-position: 50%
        background-repeat: no-repeat
        background-size: cover
  &__select-date-wrapper
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 8px
  &__select-date
    font-size: 16px
    line-height: 27px
    color: #000000
  &__arrow
    display: flex
    align-items: center
    cursor: pointer
    user-select: none
    svg
      width: 13px
      height: 8px
      fill: rgba(0, 0, 0, .5)

      &:hover
        svg
          fill: rgba(0, 0, 0, .8)
  &__week-day,
  &__number-day
    display: flex
    justify-content: space-between
    span
      display: flex
      justify-content: center
      align-items: center
      width: calc(100%/7)
      height: 30px
      font-size: 14px
      line-height: 16px
      user-select: none
  &__week-day
    span
      color: #000000
      opacity: .5
  &__number-day
    flex-wrap: wrap
    .on
      cursor: pointer
    .on:hover
      border-radius: 50%
      background-color: #EEF1F4
    .off
      opacity: .4
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/datepicker.vue